import React, { useCallback, useEffect, useRef, useState } from 'react'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import { useDispatch } from 'react-redux'
import { setAuthLogout } from '../../reducers/authSlice'
import { Link } from 'react-router-dom'
import { ArrowForwardIosOutlined, ArrowBackIosOutlined, FiberSmartRecordRounded, sideNavigation, } from '../../utils/constants'
import { login, logout } from '../../assets'
import { AppDispatch } from '../../reducers/store'

import './sideNavigation.css'

const SideNavigation = ({ handleClickSideNav, sideNavToggle, user, setUser, authData }: any) => {
  const dispatch                                = useDispatch<AppDispatch>();
  const [selectedCategory, setSelectedCategory] = useState<Record<number, boolean>>({});
  const inactivityTimeoutRef                    = useRef<number | null>(null);
  const tokenTimeoutRef                         = useRef<number | null>(null);

  const handleSelectedCategory = (index: number) => () => {
    setSelectedCategory(prev => {
      const newState = {} as Record<number, boolean>;
      Object.keys(prev).forEach(key => {
        newState[Number(key)] = false;
      });
      newState[index] = !prev[index];
      return newState;
    });
  };

  const logoutUser = useCallback(() => {
    dispatch(setAuthLogout());
    localStorage.clear();
    setUser(null)
    window.location.reload();
  }, [dispatch, user]);

  useEffect(() => {
    if (!authData?.token) return;

    const logout = () => {
      dispatch(setAuthLogout());
      localStorage.clear();
      setUser(null)
      window.location.reload();
    };

    const resetInactivityTimer = () => {
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }

      inactivityTimeoutRef.current = window.setTimeout(() => {
        logout();
      }, 60 * 60 * 1000);
    };

    const decoded = jwtDecode<JwtPayload>(authData.token);
    const now = Date.now() / 1000;

    if (decoded.exp && decoded.exp < now) {
      logout();
    } else if (decoded.exp) {
      tokenTimeoutRef.current = window.setTimeout(
        logout,
        (decoded.exp - now) * 1000
      );
    }

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "resize", "keyup", "click", "keypress",]; // remove mousemove for testing

    events.forEach((event) =>
      window.addEventListener(event, resetInactivityTimer)
    );

    resetInactivityTimer();

    return () => {
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }
      if (tokenTimeoutRef.current) {
        clearTimeout(tokenTimeoutRef.current);
      }

      events.forEach((event) =>
        window.removeEventListener(event, resetInactivityTimer)
      );
    };
  }, [authData?.token, dispatch]);

  return (
    <>
      <div className={sideNavToggle ? "sideNav" : "sideNav active"}>
        <div className='sideNav-top' onClick={handleClickSideNav}>
          <h3 className={sideNavToggle ? 'sideNav-top-header active' : 'sideNav-top-header'}> Admin</h3>
          <div className={sideNavToggle ? 'sideNav-top-button active' : 'sideNav-top-button'} >
            {sideNavToggle ? <ArrowBackIosOutlined /> : <ArrowForwardIosOutlined />}
          </div>
        </div>

        {user ? (
          <>
            <div className="list-nav-container">
              {sideNavigation.map((link, index) => (
                <div key={index} className='list-nav'>
                  {/* // {`item-nav ${selectedCategory[index] === link.path && 'active'}`} */}
                  <div className={`item-nav ${selectedCategory[index] && 'active'}`} onClick={handleSelectedCategory(index)}>
                    {link.path ? (
                      <Link to={link.path} className='link-nav' title={link.name}>
                        <span className='item-nav-icon'><img src={link.image} alt={link.name} /></span> 
                        <span className='link-nav-text'>{link.name}</span>
                      </Link>
                    ) : (
                      <div className='link-nav' title={link.name}>
                        <span className='item-nav-icon'><img src={link.image} alt={link.name} /></span> 
                        <span className='link-nav-text'>{link.name}</span>
                      </div>
                    )}
                    {link.icon && React.createElement(link.icon)}
                  </div>

                  {!link.path && (
                    <ul className={`sidebar-list-nav-dropdown-cover ${selectedCategory[index] && 'active'}`}>
                      <li className='sidebar-list-link-dropdown-item'><Link to={link.path ?? `${link.directory}/create-${link.directory}`}><FiberSmartRecordRounded />{`create ${link.directory}`}</Link></li>
                      <li className='sidebar-list-link-dropdown-item'><Link to={link.path ?? `${link.directory}/view-${link.directory}`}><FiberSmartRecordRounded />{`view ${link.directory}`}</Link></li>
                    </ul>
                  )}
                  
                </div>
              ))}
            </div>

            <div onClick={logoutUser} className='logout-nav' title='logout'><span className='logout-nav-icon'><img src={logout} alt="Logout" /></span> <span className='logout-nav-text'>Logout</span></div>
          </>
        ) : (
          <>
            <Link to="/login" className='logout-nav' title='login'><span className='logout-nav-icon'><img src={login} alt="Login" /></span> <span className='logout-nav-text'>Login</span></Link>

            <Link to="/register" className='logout-nav' title='login'><span className='logout-nav-icon'><img src={login} alt="Login" /></span> <span className='logout-nav-text'>Sign Up</span></Link>
          </>
        )}

        {!user && (
          <span></span>
        )}
      </div>
    </>
  )
}

export default SideNavigation